import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  Language,
  getDirection,
  getFontClass,
} from "../thi/thi-translations";
import { normalizeThiLang } from "../thi/thi-lang.util";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})

export class HomeComponent implements OnInit {
  curentLang: string = "";
  landingLang: Language = "ar";
  dir: "rtl" | "ltr" = "rtl";
  fontClass = "font-cairo";
  year: number = new Date().getFullYear();

  constructor(
    public translate: TranslateService,
  ) {
    this.curentLang = localStorage.getItem("curentLang");
  }

  ngOnInit() {
    this.landingLang = normalizeThiLang(this.curentLang);
    this.dir = getDirection(this.landingLang);
    this.fontClass = getFontClass(this.landingLang);
  }
}
